import React, { useState } from 'react';
import logo from '../assets/logo.svg';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import './navbar.css';

// BEM - Block Element Modifier

const Menu = () => (
  <>
      <p><a href="#product">Our Product</a></p>
      <p><a href="#aboutus">About Us</a></p>
      <p><a href="#contact">Contact Us</a></p>
  </>
)

const Navbar = () => {
 
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className='duf__navbar'>
      <div className='duf__navbar-links'>
      <div className='duf__navbar-links_logo'>
         <a href="#home"><img src={logo} alt="logo"/></a> 
        </div>
        <div className="duf__navbar-links_container">
          <Menu />
        </div>
      </div>
      <div className="duf__navbar-menu">
          {toggleMenu
              ? <RiCloseLine color="#4324FF" size={24} onClick={() => setToggleMenu(false)}/>
              : <RiMenu3Line color="#4324FF" size={24} onClick={() => setToggleMenu(true)}/>
          }
          {toggleMenu && (
              <div className="duf__navbar-menu_container scale-up-center">
                  <div className="duf__navbar-menu_container-links">
                      <Menu />
                  </div>
              </div>
          )}
      </div>
    </div>
  )
}

export default Navbar;